import { useNearViewport } from "../../hooks/useNearViewport";

// Keep the image's space, but start its request only near the visible page.
export default function DeferredImage({ src, width, height, style, ...props }) {
  const [ref, isNear] = useNearViewport("1200px 400px");
  return (
    <img
      {...props}
      ref={ref}
      src={isNear ? src : undefined}
      width={width}
      height={height}
      loading={isNear ? "eager" : "lazy"}
      decoding="async"
      style={{ display: "block", ...style, aspectRatio: `${width} / ${height}`, visibility: isNear ? undefined : "hidden" }}
    />
  );
}
